import { RootState } from "@/AppRedux/reducers"
import { useSelector } from "react-redux"

const BookingStateHook = () => {
  const bookingState = useSelector((state: RootState) => state.booking)
  const {
    search,
    availableRooms,
    cart,
    guestInfo,
    bookingRef,
    discountAmount,
    couponCode,
    loading,
    error
  } = bookingState;

  return {
    search,
    availableRooms,
    cart,
    guestInfo,
    bookingRef,
    discountAmount,
    couponCode,
    loading,
    error
  };
};
export default BookingStateHook